import React, {useLayoutEffect} from 'react'
import PreloaderContainer from '@components/layout/preloader/preloader.component'
import { connect } from 'react-redux'
import {Layout} from '@components/layout';


function FallbackContainer(props) {
    useLayoutEffect(() => {
        props.openPreloader()
    });

    useLayoutEffect(() => {
        props.closePreloader()
    }, []);

    return <PreloaderContainer />
}

const mapStateToProps = (state, props) => ({});

const actions = {
    openPreloader: Layout.actions.openPreloader,
    closePreloader: Layout.actions.closePreloader,
};

export default connect(mapStateToProps, actions)(FallbackContainer)